import { Button, Typography } from '@breetometer/components';
import { CryptoDestinationIcon } from 'BreetAssets';
import { ReceiveCurrencyBadge } from 'BreetComponents';
import { openModal, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

const CryptoDestinationBanner = () => {
	const dispatch = useAppDispatch();

	const openCryptoSettings = useCallback(() => {
		dispatch(openModal({ id: 'cryptoSettings' }));
	}, [dispatch]);

	return (
		<Button
			className='cryptodestinationbanner border-dark-navy bg-primary-400'
			variant='native'
			onClick={openCryptoSettings}
		>
			<div className='cryptodestinationbanner_label bg-primary-500'>
				<CryptoDestinationIcon />
				<Typography
					as='span'
					variant='paragraph_2'
					className='color-primary-100'
				>
					Where should your crypto go?
				</Typography>
			</div>
			<ReceiveCurrencyBadge />
		</Button>
	);
};

export default CryptoDestinationBanner;
